<template>
  <BForm
    @submit.prevent="buscar"
    class="form__barbeiro">
    <InputSugestaoBarbeiros
      ref="inputBarbeiro"
      label="Barbeiro*"
      name="inputBarbeiro"
      class="input__barbeiro"
      v-model="form.barbeiro"
      v-validate="'required'"
      :errorsBag="errors" />

    <InputBasico
      type="date"
      label="Data inicial"
      name="inputDataInicial"
      class="input__datainicial"
      v-model="form.dataInicial"
      v-validate="'required'"
      :errorsBag="errors" />

    <InputBasico
      type="date"
      label="Data final"
      name="inputDataFinal"
      class="input__datafinal"
      v-model="form.dataFinal"
      v-validate="'required'"
      :errorsBag="errors" />

    <div class="botao__container">
      <BButton
        type="submit"
        variant="primary"
        class="botao">
        Buscar valores
      </BButton>

      <BButton
        @click.prevent="limpar"
        variant="outline-primary"
        class="botao">
        Limpar
      </BButton>
    </div>
  </BForm>
</template>

<script>
import moment from 'moment'

import { BForm, BButton } from 'bootstrap-vue/es/components'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputSugestaoBarbeiros from '../../components/inputs/sugestao/InputSugestaoBarbeiros.vue'

export default {
  name: 'PagarBarbeiroForm',
  components: {
    BForm,
    BButton,
    InputBasico,
    InputSugestaoBarbeiros,
  },
  data() {
    return {
      form: this.valoresIniciaisForm(),
    }
  },
  mounted() {
    this.focarPrimeiroCampo()
  },
  methods: {
    valoresIniciaisForm() {
      return {
        barbeiro: null,
        dataInicial: this.retornaDataAtual(),
        dataFinal: this.retornaDataAtual(),
      }
    },
    retornaDataAtual() {
      return moment().format('YYYY-MM-DD')
    },
    retornaCamposGravar() {
      return this.form
    },
    buscar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const filtro = {
            funcionarioId: this.form.barbeiro._id,
            dataInicial: this.form.dataInicial,
            dataFinal: this.form.dataFinal,
          }

          this.$emit('buscar', filtro)
        }
      })
    },
    limpar() {
      this.form = this.valoresIniciaisForm()
      this.focarPrimeiroCampo()
      this.$emit('limpar')
    },
    focarPrimeiroCampo() {
      this.$refs.inputBarbeiro.focar()
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.form__barbeiro {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 0.8em;
  }
}

.input {
  &__barbeiro {
    @media (min-width: $small-size) {
      grid-column: 1 / -1;
    }
  }

  &__datainicial {
    @media (min-width: $small-size) {
      grid-column: 1 / 2;
    }
  }

  &__datafinal {
    @media (min-width: $small-size) {
      grid-column: 2 / 3;
    }
  }
}

// .botoes {
//   grid-column: 1 / -1;
//   display: flex;
//   justify-content: flex-end;
//   width: 100%;
// }

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
